import React, { Dispatch, SetStateAction } from 'react';
import classNames from 'classnames';
import { BaseProps } from '../../types';
import styles from './StepDots.module.css';

function StepDots({
  className,
  dots,
  active,
  setactive,
  ...props
}: {
  dots: { link?: string; key: string }[];
  active: string;
  setactive?: Dispatch<SetStateAction<string>>;
} & BaseProps) {
  return (
    <div
      className={classNames(
        className,
        styles.dotContainer,
      )}
      {...props}
    >
      {dots.map((item) => (
        <div
          role="none"
          className={classNames(styles.dot, {
            [styles.dotActive]: item.key === active,
            'with-cursor-pointer': setactive,
          })}
          onClick={setactive ? () => setactive(item.key) : () => null}
        />
      ))}
    </div>
  );
}

StepDots.defaultProps = {
  setactive: undefined,
};

export default StepDots;
